import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const MoreOutlinedSvg = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.1875 3.91406C9.1875 4.26216 9.32578 4.596 9.57192 4.84214C9.81806 5.08828 10.1519 5.22656 10.5 5.22656C10.8481 5.22656 11.1819 5.08828 11.4281 4.84214C11.6742
      4.596 11.8125 4.26216 11.8125 3.91406C11.8125 3.56597 11.6742 3.23213 11.4281 2.98598C11.1819 2.73984 10.8481 2.60156 10.5 2.60156C10.1519 2.60156 9.81806 2.73984
      9.57192 2.98598C9.32578 3.23213 9.1875 3.56597 9.1875 3.91406ZM9.1875 10.4766C9.1875 10.8247 9.32578 11.1585 9.57192 11.4046C9.81806 11.6508 10.1519 11.7891 10.5
      11.7891C10.8481 11.7891 11.1819 11.6508 11.4281 11.4046C11.6742 11.1585 11.8125 10.8247 11.8125 10.4766C11.8125 10.1285 11.6742 9.79463 11.4281 9.54849C11.1819
      9.30234 10.8481 9.16406 10.5 9.16406C10.1519 9.16406 9.81806 9.30234 9.57192 9.54849C9.32578 9.79463 9.1875 10.1285 9.1875 10.4766ZM9.1875 17.0391C9.1875 17.3872
      9.32578 17.721 9.57192 17.9671C9.81806 18.2133 10.1519 18.3516 10.5 18.3516C10.8481 18.3516 11.1819 18.2133 11.4281 17.9671C11.6742 17.721 11.8125 17.3872 11.8125
      17.0391C11.8125 16.691 11.6742 16.3571 11.4281 16.111C11.1819 15.8648 10.8481 15.7266 10.5 15.7266C10.1519 15.7266 9.81806 15.8648 9.57192 16.111C9.32578
      16.3571 9.1875 16.691 9.1875 17.0391Z"
      fill="currentColor"
    />
  </svg>
);

const MoreOutlined = (props: IIconProps) => <Icon component={MoreOutlinedSvg} {...props} />;

export default MoreOutlined;
